import React, { useState, useEffect } from 'react'
import { GroupedBarChart } from "@carbon/charts-react";
import TableToolbarDownload from '../../common/TableToolbarDownload';
import * as DashboardConstants from './DashboardConstants'

const DashboardGroupedBarChart = (props) => {
    const [yAxisThreshold, setYAxisThreshold] = useState();

    const defaultGroupedBarGraphOptions = {
        "title": "",
        "axes": {
            "left": {
                "mapsTo": "value",
                "title": props.graphAxesTitle,
                "percentage": props.isPercentage,
                "thresholds": yAxisThreshold
            },
            "bottom": {
                "scaleType": "labels",
                "mapsTo": "key",
                "title": props.graphBottomTitle,
            },
        },
        "legend": {
            "position": "top",
            "orientation": "horizontal",
            "alignment": "right"
        },
        "data": {
            "loading": props.loading
        },
        "height": props.height ? props.height : "400px",
        "toolbar": { "enabled": props.toolbarEnabled === false ? false : true },
    };

    const groupedBarGraphHeaders = [{ key: 'group', header: DashboardConstants.Group }, { key: 'key', header: DashboardConstants.key },
    { key: 'value', header: DashboardConstants.Value }];

    useEffect(() => {
        if (props.yAxisthresholds && !props.loading) {
            setYAxisThreshold(props.yAxisthresholds)
        }
    }, [props.loading]);

    return (
        <>
            <div className="dashboard-grouped-bar-graph">
                <div className="graph-title carbon-display-Regular-20">
                    <div>{props.title}</div>
                    {!props.hideDownloadButton ?
                        <div className="download-button">
                            <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={props.downloadableData || props.groupedBarChartData} headers={props.headers || groupedBarGraphHeaders} title={props.title} filename={DashboardConstants.Export} label={DashboardConstants.Download} />
                        </div>
                        :
                        ''
                    }
                </div>
                {!defaultGroupedBarGraphOptions.data.loading && !props.groupedBarChartData.length ?
                    <div>{DashboardConstants.NoDataAvailable}</div>
                    :
                    <GroupedBarChart
                        data={props.groupedBarChartData}
                        options={defaultGroupedBarGraphOptions}>
                    </GroupedBarChart>
                }
            </div>
        </>
    );
};

export default DashboardGroupedBarChart;
